import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.8rem;
  padding: 2rem 0 1.5rem;
  color: #ffffff;
  background-color: ${({ $color }) => $color};
`;

export const Message = styled.span`
  font-weight: 600;
  text-align: center;
`;
